import { render } from "./ValidationInfoIndex.vue?vue&type=template&id=1f0a760c"
import script from "./ValidationInfoIndex.vue?vue&type=script&lang=js"
export * from "./ValidationInfoIndex.vue?vue&type=script&lang=js"

import "./ValidationInfoIndex.vue?vue&type=style&index=0&id=1f0a760c&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCard,QCardSection,QTable,QToggle,QBadge,QInput,QIcon,QTd,QInnerLoading});
